<template>
  <!-- NOTIFICATIONS -->
  <div @click="onDropDownClick()" style="position:relative">
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="unreadNtfMsg.length" :class="{ 'shake' : animatedBell }" />

      <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown sticked">

        <div class="notification-top text-center p-5 bg-primary text-white">
          <h3 class="text-white"> Notificações do usuário</h3>
          
        </div>

        <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
          <div v-if="!notificationsMsg.length" class="flex items-center justify-center">
            <h6 class="mt-6 mb-6 text-grey"> Não há notificações </h6>
          </div>
          <ul class="bordered-items">
            <li v-for="ntf in sortedNftMsg" :key="ntf.index" class="flex justify-between px-4 py-4 notification cursor-pointer" @click="onClickNotification(ntf.payload)">
              <component v-if="ntf.is" :is="ntf.is" v-bind="ntf" :notification="ntf"/>
              <simple-notification v-else :notification="ntf"/>
            </li>
          </ul>
        </VuePerfectScrollbar>

        <div class="
          danger
          checkout-footer
          fixed
          bottom-0
          rounded-b-lg
          text-primary
          w-full
          p-2
          font-semibold
          text-center
          border
          border-b-0
          border-l-0
          border-r-0
          border-solid
          d-theme-border-grey-light">
          <span> {{ notificationsMsg.length }} {{ notificationsMsg.length > 1 ? 'notificações' : 'Notificação' }}</span>
        </div>
      </vs-dropdown-menu>
    </vs-dropdown>

    <modal-users-orders 
      :visible="modalBillUsersOrders.visible"
      :table="modalBillUsersOrders.table"
      @close="(value) => modalBillUsersOrders.visible = value"
      @add-order="addItemToTable"
    />

    <a-modal
        :maskClosable="true"
        :width="900"
        :zIndex="90000"
        :footer="null"
        :title="`Mesa ${modalNewOrder.table && modalNewOrder.table.table.number}`"
        destroyOnClose
        @cancel="cleanUpOrdersOnBag"
        v-model="modalNewOrder.visible">
        <new-order
            :table="modalNewOrder.table"
            @saved="onSaved"
        />
    </a-modal>

  </div>
</template>

<script>
import firebase from '@/firebase/firebase'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import ModalUsersOrders from '@/components/bill/ModalUsersOrders'
import NewOrder from '@/components/bill/NewOrder'
import SimpleNotification from './SimpleNotification.vue'
import NewInviteNotification from './NewInviteNotification.vue'

const db = firebase.firestore()

export default {
  components: {
    NewOrder,
    ModalUsersOrders,
    VuePerfectScrollbar,
    SimpleNotification,
    NewInviteNotification
  },

  data() {
    return {
      animatedBell : false,
      modalNewOrder : {
        table : null,
        visible : false
      },
      modalBillUsersOrders : {
        table : {},
        visible : false
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60,
      },
    }
  },

  computed : {
      ...mapState('notifications', ['notificationsMsg']),
      ...mapGetters('notifications', ['unreadNtfMsg', 'sortedNftMsg'])
  },

  watch : {
    unreadNtfMsg : {
      handler (val) {
        if(val.length) {
          this.animatedBell = true
          setTimeout(() => {
            this.animatedBell = false
          }, 1000)
        }
      },
      deep : true
    }
  },  

  methods: {
    cleanUpOrdersOnBag () {
                this.cleanUp()
            },

    onSaved() {
        this.modalNewOrder.table = null;
        this.modalNewOrder.visible = false;
    },

    addItemToTable(table) {
      this.modalNewOrder.table = table;
      this.modalNewOrder.visible = true;
    },

    async onClickNotification (payload = null) {
      if(!payload) return

      if(payload.hasOwnProperty('billId')) {
        try {
          this.$vs.loading()
          const companyId = this.$store.getters.getCompanyID
          const refBill = await db.collection(`/company/${companyId}/bill`).doc(payload.billId).get()

          if(refBill.data().isClosed) {
            this.$error({
              zIndex : 999999,
              title : 'Erro',
              content: 'A mesa já foi fechada',
              okType : 'danger'
            })

            return
          }

          this.modalBillUsersOrders = {
            table : refBill.data(),
            visible : true,
          }

          let billSnap = db.collection(`/company/${companyId}/bill`).doc(payload.billId)
            .onSnapshot(snapshot => {
                const doc = snapshot.data()
                if(doc.isClosed) {
                  this.modalBillUsersOrders = {
                    table : {}, 
                    visible : false
                  }
                  billSnap = null
                }
                else 
                  this.$set(this.modalBillUsersOrders, 'table', doc)
            })
            
        } catch (err) {
          this.$error({
            title : 'Erro ao visualizar mesa!',
            content : err.message,
            okType: 'danger'
          })
        } finally {
          this.$vs.loading.close()
        }
      }
    },
    
    onDropDownClick () {
      this.readAllMsg()
    },

    // Method for creating dummy notification time
    randomDate({ hr, min, sec }) {
      let date = new Date()

      if (hr) date.setHours(date.getHours() - hr)
      if (min) date.setMinutes(date.getMinutes() - min)
      if (sec) date.setSeconds(date.getSeconds() - sec)

      return date
    },

    ...mapMutations('order', ['cleanUp']),
    ...mapActions('notifications', ['readAllMsg'])
  }
}

</script>

<style>
    .sticked {
        /* position: relative; */
    }

    .shake {
      animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
      transform: translate3d(0, 0, 0);
    }
    @keyframes shake {
      10%, 90% {
        transform: translate3d(-1px, 0, 0);
      }
      20%, 80% {
        transform: translate3d(2px, 0, 0);
      }
      30%, 50%, 70% {
        transform: translate3d(-4px, 0, 0);
      }
      40%, 60% {
        transform: translate3d(4px, 0, 0);
      }
    }
</style>